<div *ngIf="story?.caseStudyNomination !== null" class="field">
  {{ story?.caseStudyNomination ? storyCaseStudyNominationDescriptor[story.caseStudyNomination].Label : '' }}
</div>
<div *ngIf="story?.caseStudyNominationNotes !== null && !isReadOnly" class="field">
  {{ story?.caseStudyNominationNotes }}
</div>
<div class="updateCancelButtons" *ngIf="!isReadOnly">
  <button mat-button *ngIf="currentUserIsStoryOwner" color="primary" (click)="switchToEdit.emit()">CHANGE</button>
</div>
